import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "d-flex mt-4" }
const _hoisted_3 = { class: "my-4" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "font-weight-bold mr-4" }
const _hoisted_7 = {
  key: 0,
  class: "font-weight-bold primary--text ml-2"
}
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = {
  key: 2,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Class Diary", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.downloadDiaries,
        disabled: _ctx.isSearching,
        color: "primary",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-6 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { fluid: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Class", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.classId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classId) = $event)),
                      items: _ctx.classes,
                      "item-title": (item) => `(${item.year}) ${item.className}`,
                      "item-value": "classId",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      clearable: "",
                      disabled: _ctx.isSearching,
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "item-title", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("h5", null, "Date (Start)", -1)),
                    _createVNode(_component_date_picker, {
                      modelValue: _ctx.from,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.from) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createElementVNode("h5", null, "Date (End)", -1)),
                    _createVNode(_component_date_picker, {
                      modelValue: _ctx.to,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.to) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "mt-4 pl-4" }, " Unapproved ", -1)),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "mt-10 ml-0 pl-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.check,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.check) = $event)),
                      disabled: _ctx.isSearching,
                      color: "primary"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "mt-4 search-button",
                      color: "primary",
                      variant: "flat",
                      large: "",
                      onClick: _ctx.searchBtn,
                      loading: _ctx.isSearching
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, "Search Results: " + _toDisplayString(_ctx.diaries.length) + " items", 1),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "primary",
          variant: "flat",
          large: "",
          to: `/class-diaries/create?classId=${_ctx.classId}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("mdi-plus", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.create')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sorted, (d) => {
          return (_openBlock(), _createBlock(_component_v_card, {
            key: d.classDiaryId,
            class: "py-2 px-4 my-2",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getClassName(d.classId)), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(d.date)), 1)
                ]),
                (_ctx.isToday(d.date))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Today's Diary"))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                _createElementVNode("div", _hoisted_8, [
                  (d.approvedBy.chief && d.approvedBy.chief != -1)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: "primary",
                        class: "mx-1",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[13] || (_cache[13] = _createTextVNode(" Chief ", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (d.approvedBy.director && d.approvedBy.director != -1)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        color: "primary",
                        class: "mx-1",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[15] || (_cache[15] = _createTextVNode(" Director ", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (d.status == 'draft')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_v_chip, {
                          variant: "outlined",
                          class: "mx-1"
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("Draft ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => (_ctx.deleteClassDiary(d.classDiaryId)),
                          color: "red",
                          class: "mx-1",
                          variant: "flat",
                          dark: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (d.status === 'applied')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 3,
                        color: "primary",
                        variant: "outlined",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("Applied", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_btn, {
                  class: "ml-4",
                  variant: "flat",
                  color: "primary",
                  to: `/class-diaries/${d.classId}/${d.classDiaryId}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _createVNode(_component_v_pagination, {
      class: "pt-4",
      modelValue: _ctx.page,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page) = $event)),
      onInput: _ctx.pageClick,
      length: Math.ceil(_ctx.totalItemsCount / _ctx.limit)
    }, null, 8, ["modelValue", "onInput", "length"])
  ]))
}